// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1pFut","colCheckbox":"styles_colCheckbox__35WI9"};